var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { Message } from '@patsnap/tahiti-core/common/message';
import { I18nService } from '@/services/i18n-service';
function isImage(file) {
    return _.includes(['image/jpeg', 'image/png', 'image/gif'], file.type);
}
/**
 * Represents the size limit of the image (2M).
 */
const SIZE_LIMIT_2M = 1024 * 1024 * 2;
let SpaceCoverImageReaderImp = class SpaceCoverImageReaderImp {
    constructor(_message, _i18nService) {
        this._message = _message;
        this._i18nService = _i18nService;
    }
    readCoverImage(file) {
        if (!isImage(file)) {
            this._message.error({
                message: this._i18nService.t('workspace.tips.imageTypeError'),
            });
            return Promise.reject();
        }
        if (file.size > SIZE_LIMIT_2M) {
            this._message.error({
                message: this._i18nService.t('workspace.tips.uploadLimit'),
            });
            return Promise.reject();
        }
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                resolve(e.target.result);
            };
            reader.onerror = (err) => {
                return Promise.reject(err);
            };
            reader.readAsDataURL(file);
        });
    }
};
SpaceCoverImageReaderImp = __decorate([
    injectable(),
    __param(0, inject(Message)),
    __param(1, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof Message !== "undefined" && Message) === "function" ? _a : Object, typeof (_b = typeof I18nService !== "undefined" && I18nService) === "function" ? _b : Object])
], SpaceCoverImageReaderImp);
export { SpaceCoverImageReaderImp };
